<template>
  <div class="app-calendar border">
    <div class="row no-gutters">
      <!-- Sidebar -->
      <div
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{ show: isCalendarOverlaySidebarActive }"
      >
        <calendar-sidebar
          :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive"
        />
      </div>

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            <full-calendar
              ref="refCalendar"
              :options="calendarOptions"
              class="full-calendar"
            >
            </full-calendar>
          </div>
        </div>
      </div>

      <!-- Sidebar Overlay -->

      <div
        class="body-content-overlay"
        :class="{ show: isCalendarOverlaySidebarActive }"
        @click="isCalendarOverlaySidebarActive = false"
      ></div>
      <!-- <calendar-event-handler
        v-model="isEventHandlerSidebarActive"
        :event="event"
        :clear-event-data="clearEventData"
        @remove-event="removeEvent"
        @add-event="addEvent"
        @update-event="updateEvent"
      /> -->
      <b-modal
        centered
        @ok="add_record"
        :title="lang('t_addEvent')"
        v-model="isEventHandlerSidebarActive"
        max-width="540"
      >
        <!-- Event Title -->

        <b-form-group label="" label-for="event-name">
          <b-form-input
            id="event-name"
            v-model="currentData.event_name"
            autofocus
            trim
            :placeholder="lang('t_eventName')"
          />
        </b-form-group>

        <!-- Event Note -->

        <b-form-group label="" label-for="eventNote">
          <b-form-input
            id="eventNote"
            v-model="currentData.event_note"
            autofocus
            trim
            :placeholder="lang('t_eventNote')"
          />

          <template #option="{ color, label }">
            <div
              class="rounded-circle d-inline-block mr-50"
              :class="`bg-${color}`"
              style="height: 10px; width: 10px"
            />
            <span> {{ label }}</span>
          </template>

          <template #selected-option="{ color, label }">
            <div
              class="rounded-circle d-inline-block mr-50"
              :class="`bg-${color}`"
              style="height: 10px; width: 10px"
            />
            <span> {{ label }}</span>
          </template>
        </b-form-group>

        <!-- Number -->

        <b-form-group label="" label-for="number">
          <b-form-input
            id="number"
            v-model="currentData.event_contact_number"
            autofocus
            trim
            :placeholder="lang('t_number')"
          />

          <template #option="{ color, label }">
            <div
              class="rounded-circle d-inline-block mr-50"
              :class="`bg-${color}`"
              style="height: 10px; width: 10px"
            />
            <span> {{ label }}</span>
          </template>

          <template #selected-option="{ color, label }">
            <div
              class="rounded-circle d-inline-block mr-50"
              :class="`bg-${color}`"
              style="height: 10px; width: 10px"
            />
            <span> {{ label }}</span>
          </template>
        </b-form-group>

        <!-- Date & Time -->

        <b-form-group label="" label-for="end-date">
          <flat-pickr
            v-model="currentData.event_start_time"
            class="form-control"
            :config="{
              dateFormat: 'Y-m-d H:i',
              time_24hr: true,
              enableTime: true,
              allowInput: true,
            }"
            :placeholder="lang('t_eventDate')"
          />
        </b-form-group>
        <b-form-group :label="lang('t_tags')" label-for="event-color">
          <!-- <b-button
              class="mr-1"
              style="height: 5vh"
              size="lg"
              v-for="(item, i) in cal_colors"
              :key="i"
              @click="currentData.event_color = item.color"
              :variant="item.color"
            >
              <feather-icon
                size="18"
                v-if="currentData.event_color == item.color"
                icon="CheckIcon"
              ></feather-icon>
            </b-button> -->

          <div
            v-b-tooltip.hover="{ variant: item.color }"
            v-b-tooltip.hover.bottom="item.description"
            v-for="(item, index) in cal_colors"
            :key="index"
            class="p-1 d-inline-block rounded mr-1 cursor-pointer"
            :class="[
              `bg-${item.color}`,
              { 'border border-light': !index },
              currentData.event_color == item.color ? 'mark-active' : '',
            ]"
            @click="currentData.event_color = item.color"
          />
        </b-form-group>
      </b-modal>
      <b-modal
        v-if="event.extendedProps.agent"
        @show="getCustomerDetails"
        no-close-on-esc
        no-close-on-backdrop
        centered
        :title="`${event.extendedProps.agent.split('@')[0]} - ${
          event.title
        } - ${new Date(
          new Date(event.start || 0).getTime() + 3 * 60 * 60 * 1000
        )
          .toISOString()
          .replace(/([^T]+)T([^\.]+).*/g, '$1 $2')}`"
        v-model="isEventDedailtsModalActive"
        max-width="540"
        :ok-title="GetTitle(event.extendedProps.contact_number)"
        :cancel-title="lang('t_displayOnCRM')"
        @ok="start_call(event.extendedProps.contact_number)"
        @cancel="displayOnCRM(event.extendedProps.contact_number)"
      >
        <span
          >{{ event.extendedProps.customer_no }} -
          {{ event.extendedProps.customer_name }}</span
        >
        <br />
        <span>{{ event.extendedProps.description }}</span>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BAvatar,
  BFormTextarea,
  BButton,
  BFormInvalidFeedback,
  BRow,
  VBTooltip,

} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import calendarStoreModule from "./calendarStoreModule";
import CalendarSidebar from "./calendar-sidebar/CalendarSidebar.vue";
import CalendarEventHandler from "./calendar-event-handler/CalendarEventHandler.vue";
import useCalendar from "./useCalendar";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BAvatar,
    BFormTextarea,
    BButton,
    BFormInvalidFeedback,
    BRow,
    BModal,
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    CalendarEventHandler,

  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mounted: function () {
    globalThis.calendar = this;
    this.other_permissions = globalThis.permissions["other"] ?? [];
    console.log("refCalendar", this.$refs.refCalendar);
    this.calendarOptions.events = [];
    this.getEvents();
  },
  data() {
    return {
      lang: _l(window.localStorage.getItem("language") || "tr"),
      isEdit: false,
      other_permissions: [],
      currentData: {
        event_name: "",
        event_note: "",
        event_owner: "",
        event_contact_number: "",
        event_date: "",
        event_start_time: "",
        event_end_time: "",
        event_color: "primary",
      },
      cal_colors: [
        {
          color: "danger",
          label: "Personal",
          description: globalThis._lang('t_important'),
        },
        {
          color: "primary",
          label: "Business",
          description: globalThis._lang('t_appointment'),
        },
        {
          color: "warning",
          label: "Family",
          description: globalThis._lang('t_reminder'),
        },
        {
          color: "success",
          label: "Holiday",
          description: globalThis._lang('t_personaly'),
        },
        {
          color: "info",
          label: "ETC",
          description: globalThis._lang('t_other'),
        },
      ],
      records: [
        {
          title: "test",
          start: "2022-04-21 14:00",
          end: "2022-04-21 14:00",
          allDay: false,
          url: "",
          extendedProps: {
            calendar: "",
            guests: [],
            location: "locaton",
            description: "desc",
          },
        },
      ],
    };
  },
  methods: {
    GetTitle(_phone) {
      if (this.other_permissions.includes('mask_remote_number')) {
        return `${globalThis._lang('t_call')}: ${globalThis.maskPhoneNumber(_phone)}`

      } else {
        return `${globalThis._lang('t_call')}: ${_phone}`
      }

    },
    async displayOnCRM(phone) {
      console.log(phone);
      await this.$router.replace('/crm');

      globalThis.v_navbar.selected_button = 'crm';
      setTimeout(() => {
        if (globalThis.crm) {
          globalThis.crm.getCustomerByPhone(phone.slice(-10));
        }
      }, 1000);


    },
    async getCustomerDetails() {
      var response = (
        await this.$http_in.get(
          `/crm/v1/CustomersByPhone/${this.event.extendedProps.contact_number.substr(
            -10
          )}`
        )
      ).data;

      this.event.extendedProps.customer_no =
        response.result.length > 0
          ? response.result[0].hasOwnProperty("customer_name")
            ? response.result[0]["customer_name"]
            : ""
          : "";
      this.event.extendedProps.customer_name =
        response.result.length > 0
          ? response.result[0].hasOwnProperty("customer_no")
            ? response.result[0]["customer_no"]
            : ""
          : "";
    },
    start_call(phone) {
      globalThis.LayoutContentRendererDefault.preview_call_request(phone);
    },
    getEvents: async function (filter = ["primary", "warning", "success", "info", "danger"]) {
      var response = (await this.$http_in.get(this.other_permissions.includes('display_all_calendar') ? `/agent/v1/AllCalendar` : `/agent/v1/Calendar`)).data;
      this.calendarOptions.events = [];
      // const merge_events = [].concat(response[0], response[1]);
      const merge_events = response;
      for (const item of merge_events) {

        console.log("item.color", item.color);
        if (filter.includes(item.color)) {
          this.calendarOptions.events.push({
            id: item._id,
            title: item.finishcode,
            start: item.start,
            end: item.end,
            extendedProps: {
              calendar:
                this.cal_colors.find((e) => e.color == item.color) == undefined
                  ? "Personel"
                  : this.cal_colors.find((e) => e.color == item.color).label,
              guests: "",
              location: "",
              description: item.note,
              contact_number: item.contact_number,
              agent: item.agent ?? '',
            },
            allDay: false,
          });
        }

      }
      this.events = merge_events;
    },

    check_data() {
      if (
        this.currentData.event_name.trim() == "" ||
        this.currentData.event_note.trim() == "" ||
        this.currentData.event_contact_number.trim() == "" ||
        this.currentData.event_start_time.trim() == ""
      ) {
        return true;
      }
      return false;
    },

    async add_record() {
      if (this.check_data()) {
        this.$swal({
          title: globalThis._lang("t_warning"),
          text: globalThis._lang("t_pleaseDoNotLeaveAnyBlankFields"),
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }
      var response;
      response = (
        await this.$http_in.post(`/agent/v1/Calendar`, {
          EventInfo: JSON.stringify(this.currentData),
        })
      ).data;

      if (response && response.acknowledged) {
        this.$swal({
          title: globalThis._lang("t_processSuccess"),
          text: globalThis._lang("t_hasBeenCreatedSuccessfully"),
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } else {
        this.$swal({
          title: globalThis._lang("t_error"),
          text: globalThis._lang("t_AProblemOccurredwhileProcessing"),
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
      this.getEvents();
      globalThis.LayoutContentRendererDefault.getEvents();
    },
  },
  setup() {
    const CALENDAR_APP_STORE_MODULE_NAME = "calendar";

    // Register module
    if (!store.hasModule(CALENDAR_APP_STORE_MODULE_NAME))
      store.registerModule(CALENDAR_APP_STORE_MODULE_NAME, calendarStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CALENDAR_APP_STORE_MODULE_NAME))
        store.unregisterModule(CALENDAR_APP_STORE_MODULE_NAME);
    });

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      fetchEvents,
      refetchEvents,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isEventDedailtsModalActive,
    } = useCalendar();

    fetchEvents();

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      calendarOptions,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
      isEventDedailtsModalActive,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.customizer-section {
  padding: 1.5rem;
  border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }

  #skin-radio-group ::v-deep {
    .custom-control-inline {
      margin-right: 0.7rem;
    }
  }

  .form-group {
    margin-bottom: 1.5rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    ::v-deep legend {
      font-weight: 500;
    }
  }
}

.mark-active {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
}

.ps-customizer-area {
  height: calc(100% - 83px);
}
</style>
